import { WidgetLayout } from 'components/WidgetLayout'
import { getAreaIdSearchParams } from 'utils/query-params'
import { useMemo } from 'react'
import { useGetIsPortalHidden } from 'hooks/useGetIsPortalHidden'

export const WidgetPage = () => {
  const areaId = useMemo(getAreaIdSearchParams, [])
  const isPortalHidden = useGetIsPortalHidden()

  return <WidgetLayout areaId={areaId} visible={!isPortalHidden} />
}
